"use client";

import { useToast } from "@/hooks/useToast";
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast";
import {
  IconCircleCheck,
  IconAlertTriangle,
  IconInfoCircle,
} from "@tabler/icons-react";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <ToastProvider duration={4000}>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="flex items-start gap-3">
              {props.variant === "success" && (
                <IconCircleCheck
                  className="mt-[2px] h-[22px] w-[22px] shrink-0 text-[#2B8A3E]"
                  stroke={1.8}
                  size={20}
                />
              )}
              {props.variant === "warning" && (
                <IconAlertTriangle
                  className="mt-[2px] h-[22px] w-[22px] shrink-0 text-[#F2994A]"
                  stroke={1.8}
                  size={20}
                />
              )}
              {props.variant === "info" && (
                <IconInfoCircle
                  className="mt-[2px] h-[22px] w-[22px] shrink-0 text-[#2D9CDB]"
                  stroke={1.8}
                  size={20}
                />
              )}
              {props.variant === "error" && (
                <IconAlertTriangle
                  className="mt-[2px] h-[22px] w-[22px] shrink-0 text-[#EB5757]"
                  stroke={1.8}
                  size={20}
                />
              )}

              <div className="grid gap-[2px]">
                {title && (
                  <ToastTitle className="text-base font-semibold text-[#1C1E21]">
                    {title}
                  </ToastTitle>
                )}
                {description && (
                  <ToastDescription className="text-sm font-normal text-[#464C53]">
                    {description}
                  </ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
